export default __webpack_public_path__ + "static/media/chevron-up.e8c74bab.svg";